import { getToken, getRoutes } from '@/utils/cookies'

export interface UserState {
    userInfo: {
        id:             '',     // 用户ID
        username:       '',     // 用户名
        access_token:   '',     // 访问令牌，在请求头中携带，后续会取代用户ID
        group_id:       '',     // 包含角色
        group_name:     '',     // 角色名称
        channel_no:     '',     // 渠道号
        brandArr:       any[],  // 关联品牌
        user_type:      0,      // 用户类型
        parent_id:      0,      // 主账号id（合作商户）
        is_allocation:  0,      // 是否开通商户自主接单功能
        phone?:         '',     // 手机号
        send_phone?:    '',     // 提醒手机号
        is_cat:         any,    // 是否为蛋糕商户：1-是，0-否
        is_kd:          any,    // 是否为非快递蛋糕
    },
    shopRuleData: {
        is_new: '',          //根据用户类型判断是否需要弹窗
        rule_version:'',    //商户管理规范规则版本
        rule_desc: "",      //商户管理规范内容
        rule_title: "",     //商户管理规范标题
        rule_id: any,       //规则id         
        brand_ids?: '',     // 当前用户关联品牌，字符串
    },
    expressMsg:{
        express_name: ""
        express_no: ""
        order_id: ""
        order_item_id: ""
        order_no: ""
    }, //快递提醒
    promotionMsg: {
        apply_end_at: '', //促销活动截止时间
        apply_start_at:''
        name: '', //促销活动名称
    }, //促销活动提醒
    staleDatedMsg:'', //商户资质过期提醒
    obligationMsg:'',//未付款品牌提醒
    ratingMsg:'',//商家评级弹框提醒 
    reconciliationMsg:'',//未对账提醒
    StockMsg:'',//库存不足下架提醒
    catRole:any,    //1，电子券  2，实物 3, 都有
    currRoute?: any
    aliveInclude: Array<String>,
    menuWarning?: any,
    is_contracts: number, // 商户未完善法人信息提醒：0-无用，1-已完善，2-待完善且可闭关，3-待完善且不可闭关（2025-3-30 之前可关闭）
}

export const state = {
    // @ts-ignore
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || { username: '' },
    // @ts-ignore
    shopRuleData: (localStorage.getItem('shopRuleData') != 'undefined' && localStorage.getItem('shopRuleData') != null) ? JSON.parse(localStorage.getItem('shopRuleData')) : {},
    //@ts-ignore
    staleDatedMsg: (localStorage.getItem('staleDatedMsg') != 'undefined' && localStorage.getItem('staleDatedMsg') != null) ? localStorage.getItem('staleDatedMsg') : '',
    //@ts-ignore
    obligationMsg: (localStorage.getItem('obligationMsg') != 'undefined' && localStorage.getItem('obligationMsg') != null) ? localStorage.getItem('obligationMsg') : '',
    ratingMsg: (localStorage.getItem('ratingMsg') != 'undefined' && localStorage.getItem('ratingMsg') != null) ? localStorage.getItem('ratingMsg') : '',
    reconciliationMsg: (localStorage.getItem('reconciliationMsg') != 'undefined' && localStorage.getItem('reconciliationMsg') != null) ? localStorage.getItem('reconciliationMsg') : '',
    StockMsg: (localStorage.getItem('StockMsg') != 'undefined' && localStorage.getItem('StockMsg') != null) ? localStorage.getItem('StockMsg') : '',
    currRoute: {},
    aliveInclude: [],
    menuWarning: {},
    catRole:(localStorage.getItem('catRole') != 'undefined' && localStorage.getItem('catRole') != null) ? localStorage.getItem('catRole') : '',
    is_contracts: 0,
}